import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import { OrderProduct } from './components/OrderProduct/OrderProduct';
import { OrderProductSkeleton } from './components/OrderProductSkeleton/OrderProductSkeleton';
import { OrderProductsDonation } from './components/OrderProductsDonation/OrderProductsDonation';
import { IOrderProduct } from '~/types/orders';
import { emptyArray } from '~/utils/helpers';
import { productUtils } from '~/utils/productUtils';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

export const OrderProducts: FC = memo(
  observer((): ReactElement => {
    const { store: orderStore } = useOrderStoreContext();

    const isNoDonationProducts: IOrderProduct[] | undefined = orderStore.order?.products?.filter((item) => !item.is_donation);

    if (orderStore.loading) {
      return (
        <ScrollableBlock className="order-products mr-4" scrollClassName="gap-20">
          {emptyArray().map(() => (
            <OrderProductSkeleton />
          ))}
        </ScrollableBlock>
      );
    }

    return (
      <ScrollableBlock className="order-products mr-4" scrollClassName="gap-20">
        {isNoDonationProducts?.map((product) => (
          <OrderProduct key={productUtils.getOrderProductHash(product)} product={product} />
        ))}

        <OrderProductsDonation />
      </ScrollableBlock>
    );
  })
);
